/* global jQuery, window, document */
import map from 'lodash/fp/map';

const mobile_side_nav = ($) => {
  const view = document.querySelector('.view-side-anchor-navigation');
  if (view) {
    const menu = view.querySelector('.item-list > ul');
    const mobileMenu = menu.cloneNode(true);
    map(el => el.removeAttribute('id'), mobileMenu.querySelectorAll('[id]'));
    mobileMenu.classList.remove('side-anchor-menu');
    mobileMenu.classList.add('side-anchor-menu-mobile');
    const button = document.createElement('button');
    const span = document.createElement('span');
    span.innerHTML = 'Section';
    button.appendChild(span);
    const animationWrapper = document.createElement('div');
    animationWrapper.appendChild(mobileMenu);
    button.onclick = () => $(animationWrapper).slideToggle();
    const wrapper = document.createElement('div');
    wrapper.classList.add('side-anchor-menu-mobile-wrapper');
    wrapper.appendChild(button);
    wrapper.appendChild(animationWrapper);
    menu.parentNode.appendChild(wrapper);
  }
};

export default mobile_side_nav;
